import { render } from "./Subscribe.vue?vue&type=template&id=31df77e3&scoped=true"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import "./Subscribe.vue?vue&type=style&index=0&id=31df77e3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31df77e3"]])

export default __exports__